module.exports = __webpack_public_path__ + "static/Plasmoid_DeGleash-ad82e95ed230b0bbbb1a4382013cb886.webp";